const CTAregex = /\[link\](?<link>.*?)\[\/link\]\[button\](?<button>.*?)\[\/button\]\[message\](?<message>.*?)\[\/message\]/s;

const htmlTagRegex = /<[A-Za-z\/][^>]*>/g;

const stripHtmlTags = (text) => (text || "").replace(htmlTagRegex, "");

const isThereSurvey = (message) => {
    return message.includes("msgini=") &&
        message.includes("msgend=") &&
        message.includes("text=") &&
        message.includes("id=");
};

const areThereButtons = (message) => {
    return message.includes("title=") &&
        message.includes("][button") &&
        message.includes("action=");
};

const getActions = (message) => {
    const parts = message.split("action=").slice(1);
    const actions = [];
    parts.forEach((part) => {
        const end = part.indexOf("]");
        actions.push(end >= 0 ? part.substring(0, end) : part);
    });
    return actions;
};

// Returns a plain text string (no JSX). Use lineBreak="\n" for history, "<br>" for MessageItem.
const parseInteractiveToPlainText = ({ type, message, lineBreak = "\n" }) => {
    const msg = message || "";

    if (type === "CTA") {
        const match = msg.match(CTAregex);
        if (match?.groups) {
            return `${(match.groups.message || "").trim()}${lineBreak}${match.groups.button || ""}`;
        }
        return "Mensagem interativa de CTA.";
    }

    if (type === "buttons" && areThereButtons(msg)) {
        const title = msg.split("title=")[1].split("][button")[0];
        const actions = getActions(msg);
        return `${title}${lineBreak}${actions.join(", ")}`;
    }

    if (type === "survey" && isThereSurvey(msg)) {
        return "Início da pesquisa de satisfação.";
    }

    // Fallback: remove HTML tags only, keep text plain.
    return stripHtmlTags(msg);
};

export {
    CTAregex,
    isThereSurvey,
    areThereButtons,
    getActions,
    parseInteractiveToPlainText,
};